module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    staticClass: "DeviceEditor custom-scroll-bar",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "500",
      "content-class": "delete-pluviometric-chart-dialog"
    },
    model: {
      value: (_vm.deletePluviometricChartDialog),
      callback: function($$v) {
        _vm.deletePluviometricChartDialog = $$v
      },
      expression: "deletePluviometricChartDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title-text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('AddDevice.deletePluviometricChartTitle')) + "\n      ")]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "card-actions"
  }, [_c('v-btn', {
    staticClass: "secondary-btn",
    on: {
      "click": _vm.cancelDeletePluviometricChart
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('AddDevice.cancel')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "main-btn",
    on: {
      "click": _vm.deletePluviometricChart
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('AddDevice.delete')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "text-align": "-webkit-center"
    },
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-img', {
    attrs: {
      "max-height": "124",
      "max-width": "124",
      "src": require('@/assets/min-irrigation.png')
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('AddDevice.equipmentName')) + " *"),
      "title": ((_vm.$t('AddDevice.equipmentName')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.fieldRequired,
      "required": "",
      "validate-on-blur": "",
      "maxlength": "30",
      "disabled": _vm.fieldsLockedByWebhook
    },
    model: {
      value: (_vm.deviceData.name),
      callback: function($$v) {
        _vm.$set(_vm.deviceData, "name", $$v)
      },
      expression: "deviceData.name"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.loadingCharts) ? [_c('p', {
    staticClass: "pluviometric-configuration px-2"
  }, [_vm._v(_vm._s(_vm.$t('AddDevice.pluviometricConfiguration')))]), _vm._v(" "), (_vm.pluviometricChartsData.length) ? _c('v-list', {
    staticClass: "pluviometric-charts-list"
  }, [_c('v-list-item-group', {
    attrs: {
      "color": "#0098E1"
    },
    model: {
      value: (_vm.selectedPluviometricConfiguration),
      callback: function($$v) {
        _vm.selectedPluviometricConfiguration = $$v
      },
      expression: "selectedPluviometricConfiguration"
    }
  }, [_vm._l((_vm.deviceData.pluviometricCharts), function(pluviometricChart, index) {
    return [(index > 0) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-list-item', [_c('v-list-item-action', {
      staticClass: "mr-0"
    }, [(pluviometricChart.isActive) ? _c('v-icon', {
      attrs: {
        "small": "",
        "color": "#00D166"
      }
    }, [_vm._v("circle")]) : _vm._e()], 1), _vm._v(" "), (pluviometricChart.validityDate && _vm.pluviometricChartsData[index].pumpFlow.value) ? _c('v-list-item-title', {
      staticClass: "text-left"
    }, [_vm._v("\n                " + _vm._s(_vm.parseValidityDate(pluviometricChart.validityDate)) + " - " + _vm._s(_vm.pluviometricChartsData[index].pumpFlow.value) + " m3/h\n              ")]) : (pluviometricChart.validityDate && !_vm.pluviometricChartsData[index].pumpFlow.value) ? _c('v-list-item-title', {
      staticClass: "text-left"
    }, [_vm._v("\n                " + _vm._s(_vm.parseValidityDate(pluviometricChart.validityDate)) + "\n              ")]) : (!pluviometricChart.validityDate && _vm.pluviometricChartsData[index].pumpFlow.value) ? _c('v-list-item-title', {
      staticClass: "text-left"
    }, [_vm._v("\n                " + _vm._s(_vm.pluviometricChartsData[index].pumpFlow.value) + " m3/h\n              ")]) : _c('v-list-item-title', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(_vm.$t('AddDevice.newPluviometricChart')))]), _vm._v(" "), (_vm.deviceData.pluviometricCharts.length > 1) ? _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDeletePluviometricChart(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "#F93A2F"
      }
    }, [_vm._v("mdi-trash-can-outline")])], 1)], 1) : _vm._e()], 1)]
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "mt-4 ml-2",
    attrs: {
      "justify": "start"
    }
  }, [_c('a', {
    staticClass: "add-pluviometric-chart",
    on: {
      "click": _vm.addPluviometricChart
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "#0099E1"
    }
  }, [_vm._v("mdi-file-plus")]), _vm._v(" " + _vm._s(_vm.$t('PluviometricChart.addPluviometricChart')))], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-4 ml-2",
    attrs: {
      "justify": "start"
    }
  }, [_c('p', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "#00D166"
    }
  }, [_vm._v("circle")]), _vm._v(" " + _vm._s(_vm.$t('PluviometricChart.activeConfiguration')))], 1)])] : _vm._e()], 2), _vm._v(" "), _c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "12",
      "sm": "9"
    }
  }, [(_vm.loadingCharts) ? _c('div', {
    staticClass: "display-1 text-center full-height align-content-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0098E1"
    }
  })], 1) : (_vm.selectedPluviometricConfiguration !== undefined && _vm.selectedPluviometricConfiguration !== null && _vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration]) ? _c('v-form', {
    ref: "deviceForm",
    staticClass: "mt-7",
    attrs: {
      "lazy-validation": ""
    }
  }, [(_vm.deviceData.type === 2) ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "5"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.equipmentSubtypes.linear,
      "item-value": "value",
      "item-text": "label",
      "label": ((_vm.$t('AddDevice.equipmentSubtype')) + " *"),
      "title": ((_vm.$t('AddDevice.equipmentSubtype')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.fieldRequired,
      "required": "",
      "validate-on-blur": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    model: {
      value: (_vm.deviceData.subtype),
      callback: function($$v) {
        _vm.$set(_vm.deviceData, "subtype", $$v)
      },
      expression: "deviceData.subtype"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          ref: "validityDateTextField",
          attrs: {
            "label": ((_vm.$t('AddDevice.validityDate')) + " *"),
            "title": ((_vm.$t('AddDevice.validityDate')) + " *"),
            "append-icon": "mdi-calendar",
            "readonly": "",
            "outlined": "",
            "background-color": "#FFF",
            "color": "#0098E1",
            "rules": _vm.rules.fieldRequired,
            "required": "",
            "clearable": "",
            "disabled": _vm.fieldsLockedByWebhook
          },
          on: {
            "click:clear": _vm.clearValidityDate
          },
          model: {
            value: (_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration].formattedValidityDate),
            callback: function($$v) {
              _vm.$set(_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration], "formattedValidityDate", $$v)
            },
            expression: "deviceData.pluviometricCharts[selectedPluviometricConfiguration].formattedValidityDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.validityDateMenu),
      callback: function($$v) {
        _vm.validityDateMenu = $$v
      },
      expression: "validityDateMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "color": "#0098E1",
      "locale": "es-AR"
    },
    on: {
      "input": _vm.updateValidityDate
    },
    model: {
      value: (_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration].auxValidityDate),
      callback: function($$v) {
        _vm.$set(_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration], "auxValidityDate", $$v)
      },
      expression: "deviceData.pluviometricCharts[selectedPluviometricConfiguration].auxValidityDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pluviometric-file-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-file-input', {
    ref: "FileSelector",
    staticClass: "FileSelector",
    attrs: {
      "label": _vm.$t('AddDevice.pluviometricChart'),
      "title": _vm.$t('AddDevice.pluviometricChart'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.fileField,
      "prepend-icon": "",
      "clearable": false,
      "accept": _vm.allowedFileTypes
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-btn', {
          staticClass: "SearchFileBtn",
          attrs: {
            "elevation": "0",
            "color": "#0098E1",
            "dark": ""
          },
          on: {
            "click": _vm.triggerFileSelector
          }
        }, [_vm._v(_vm._s(_vm.$t('AddDevice.search')))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration].pluviometricChartFile),
      callback: function($$v) {
        _vm.$set(_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration], "pluviometricChartFile", $$v)
      },
      expression: "deviceData.pluviometricCharts[selectedPluviometricConfiguration].pluviometricChartFile"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-2 automatic-reading-col",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('div', {
    staticClass: "automatic-reading-col-inner"
  }, [_c('div', {
    staticClass: "automatic-reading-block"
  }, [(_vm.fieldsLockedByWebhook) ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "indeterminate": "",
      "color": "#FFAD46",
      "size": "24",
      "width": "2"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.fieldsLockedByWebhook) ? _c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "#FFAD46"
    }
  }, [_vm._v(_vm._s(_vm.hasAutomaticReadingForCurrentChart ? 'mdi-check-circle' : 'mdi-creation'))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text-body2 automatic-reading-label"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.automaticReading')))])], 1)])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": _vm.$t('PluviometricChart.creationDate'),
            "title": _vm.$t('PluviometricChart.creationDate'),
            "append-icon": "mdi-calendar",
            "readonly": "",
            "outlined": "",
            "background-color": "#FFF",
            "color": "#0098E1",
            "clearable": "",
            "disabled": _vm.fieldsLockedByWebhook || !_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration].pluviometricChartFile
          },
          on: {
            "click:clear": _vm.clearCreationDate
          },
          model: {
            value: (_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration].formattedCreationDate),
            callback: function($$v) {
              _vm.$set(_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration], "formattedCreationDate", $$v)
            },
            expression: "deviceData.pluviometricCharts[selectedPluviometricConfiguration].formattedCreationDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.creationDateMenu),
      callback: function($$v) {
        _vm.creationDateMenu = $$v
      },
      expression: "creationDateMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "color": "#0098E1",
      "locale": "es-AR"
    },
    on: {
      "input": _vm.updateCreationDate
    },
    model: {
      value: (_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration].auxCreationDate),
      callback: function($$v) {
        _vm.$set(_vm.deviceData.pluviometricCharts[_vm.selectedPluviometricConfiguration], "auxCreationDate", $$v)
      },
      expression: "deviceData.pluviometricCharts[selectedPluviometricConfiguration].auxCreationDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('PluviometricChart.pumpFlow')) + " *"),
      "title": ((_vm.$t('PluviometricChart.pumpFlow')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberRequired,
      "required": "",
      "validate-on-blur": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    on: {
      "input": function($event) {
        return _vm.setFieldSourceManual('pumpFlow')
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.isFieldFromWebhook('pumpFlow')) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "#FFAD46"
          }
        }, [_vm._v("mdi-creation")]) : _vm._e()]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pumpFlow.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pumpFlow, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].pumpFlow.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pumpFlow.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pumpFlow, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].pumpFlow.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.cubicMeter') + '/' + _vm.$t('PluviometricChart.units.hour'),
      "title": _vm.$t('PluviometricChart.units.cubicMeter') + '/' + _vm.$t('PluviometricChart.units.hour'),
      "value": "m3/h"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "items": _vm.brands,
      "item-value": "value",
      "item-text": "name",
      "label": ((_vm.$t('PluviometricChart.brand')) + " *"),
      "title": ((_vm.$t('PluviometricChart.brand')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.fieldRequired,
      "required": "",
      "validate-on-blur": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    on: {
      "change": _vm.onBrandChange
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.isFieldFromWebhook('brand')) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "#FFAD46"
          }
        }, [_vm._v("mdi-creation")]) : _vm._e()]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].brand),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration], "brand", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].brand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": !_vm.currentBrand || _vm.fieldsLockedByWebhook,
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "items": _vm.models,
      "item-text": "name",
      "item-value": "value",
      "label": _vm.$t('PluviometricChart.model'),
      "title": _vm.$t('PluviometricChart.model'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1"
    },
    on: {
      "change": function($event) {
        return _vm.setFieldSourceManual('model')
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.isFieldFromWebhook('model')) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "#FFAD46"
          }
        }, [_vm._v("mdi-creation")]) : _vm._e()]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].model),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration], "model", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].model"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [(!_vm.isIREquipment) ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('PluviometricChart.length')) + " *"),
      "title": ((_vm.$t('PluviometricChart.length')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberRequired,
      "required": "",
      "validate-on-blur": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    on: {
      "blur": _vm.updateDeviceLength,
      "input": function($event) {
        return _vm.setFieldSourceManual('deviceLength')
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.isFieldFromWebhook('deviceLength')) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "#FFAD46"
          }
        }, [_vm._v("mdi-creation")]) : _vm._e()]
      },
      proxy: true
    }], null, false, 347567691),
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].deviceLength.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].deviceLength, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].deviceLength.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].deviceLength.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].deviceLength, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].deviceLength.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.meter'),
      "title": _vm.$t('PluviometricChart.units.meter'),
      "value": "m"
    }
  })], 1)], 1)], 1) : _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('PluviometricChart.hoseLength')) + " *"),
      "title": ((_vm.$t('PluviometricChart.hoseLength')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberRequired,
      "required": "",
      "validate-on-blur": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    on: {
      "input": function($event) {
        return _vm.setFieldSourceManual('hoseLength')
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.isFieldFromWebhook('hoseLength')) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "#FFAD46"
          }
        }, [_vm._v("mdi-creation")]) : _vm._e()]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].hoseLength.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].hoseLength, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].hoseLength.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "disabled": _vm.fieldsLockedByWebhook,
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].hoseLength.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].hoseLength, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].hoseLength.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.meter'),
      "title": _vm.$t('PluviometricChart.units.meter'),
      "value": "m"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "5"
    }
  }, [(!_vm.isIREquipment) ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('PluviometricChart.area')) + " *"),
      "title": ((_vm.$t('PluviometricChart.area')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberRequired,
      "required": "",
      "validate-on-blur": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    on: {
      "input": function($event) {
        return _vm.setFieldSourceManual('area')
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.isFieldFromWebhook('area')) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "#FFAD46"
          }
        }, [_vm._v("mdi-creation")]) : _vm._e()]
      },
      proxy: true
    }], null, false, 1069964888),
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].area.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].area, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].area.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].area.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].area, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].area.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.hectare'),
      "title": _vm.$t('PluviometricChart.units.hectare'),
      "value": "ha"
    }
  })], 1)], 1)], 1) : _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('PluviometricChart.cannonReach')) + " *"),
      "title": ((_vm.$t('PluviometricChart.cannonReach')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberRequired,
      "required": "",
      "validate-on-blur": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    on: {
      "input": function($event) {
        return _vm.setFieldSourceManual('equipmentReach')
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.isFieldFromWebhook('equipmentReach')) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "#FFAD46"
          }
        }, [_vm._v("mdi-creation")]) : _vm._e()]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].equipmentReach.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].equipmentReach, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].equipmentReach.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "disabled": _vm.fieldsLockedByWebhook,
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].equipmentReach.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].equipmentReach, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].equipmentReach.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.meter'),
      "title": _vm.$t('PluviometricChart.units.meter'),
      "value": "m"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "category-text text-left px-2"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.pressureRange')))]), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('PluviometricChart.chartPressure')) + " *"),
      "title": ((_vm.$t('PluviometricChart.chartPressure')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberRequired,
      "required": "",
      "validate-on-blur": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    on: {
      "input": _vm.onChartPressureInput
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.isFieldFromWebhook('chartPressure')) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "#FFAD46"
          }
        }, [_vm._v("mdi-creation")]) : _vm._e()]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pressureRange.chartPressure),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pressureRange, "chartPressure", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].pressureRange.chartPressure"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pressureRange.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pressureRange, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].pressureRange.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.bar'),
      "title": _vm.$t('PluviometricChart.units.bar'),
      "value": "bar"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    ref: "minPressureField",
    attrs: {
      "label": ((_vm.$t('PluviometricChart.minPressure')) + " *"),
      "title": ((_vm.$t('PluviometricChart.minPressure')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.minPressure,
      "required": "",
      "validate-on-blur": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    on: {
      "input": function($event) {
        return _vm.setFieldSourceManual('minPressure')
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.isFieldFromWebhook('minPressure')) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "#FFAD46"
          }
        }, [_vm._v("mdi-creation")]) : _vm._e()]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pressureRange.minPressure),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pressureRange, "minPressure", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].pressureRange.minPressure"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    ref: "maxPressureField",
    attrs: {
      "label": ((_vm.$t('PluviometricChart.maxPressure')) + " *"),
      "title": ((_vm.$t('PluviometricChart.maxPressure')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.maxPressure,
      "required": "",
      "validate-on-blur": "",
      "disabled": _vm.fieldsLockedByWebhook
    },
    on: {
      "input": function($event) {
        return _vm.setFieldSourceManual('maxPressure')
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.isFieldFromWebhook('maxPressure')) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "#FFAD46"
          }
        }, [_vm._v("mdi-creation")]) : _vm._e()]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pressureRange.maxPressure),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].pressureRange, "maxPressure", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].pressureRange.maxPressure"
    }
  })], 1)], 1), _vm._v(" "), (_vm.deviceData.equipment.type !== _vm.EQUIPMENT_TYPE.IR) ? _c('v-row', {
    staticClass: "full-width"
  }, [_c('a', {
    staticClass: "advanced-cfg float-left px-2",
    on: {
      "click": function($event) {
        _vm.advancedConfigFlag = !_vm.advancedConfigFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.advancedConfigFlag ? '-' : '+') + " " + _vm._s(_vm.$t('PluviometricChart.advancedConfig')))])]) : _vm._e()], 1) : _c('div', {
    staticClass: "text-center full-height align-content-center no-pluviometric-chart-selected"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('PluviometricChart.noPluviometricChartSelected')))])])], 1), _vm._v(" "), (_vm.deviceData.equipment.type !== _vm.EQUIPMENT_TYPE.IR && !_vm.loadingCharts && _vm.selectedPluviometricConfiguration !== undefined) ? _c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.advancedConfigFlag) ? _c('v-form', {
    ref: "advancedDeviceForm",
    staticClass: "mt-7",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-row', {
    staticClass: "full-width pt-5 PluviometricChart"
  }, [_c('p', {
    staticClass: "section-text text-left full-width"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.fieldArea'))), _c('v-icon', {
    staticClass: "ml-1",
    on: {
      "click": function($event) {
        _vm.showFieldAreaSection = !_vm.showFieldAreaSection
      }
    }
  }, [_vm._v(_vm._s(_vm.showFieldAreaSection ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1), _vm._v(" "), (_vm.showFieldAreaSection) ? [_c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.fullLapArea'),
      "title": _vm.$t('PluviometricChart.fullLapArea'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.fieldArea.fullLapArea),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.fieldArea, "fullLapArea", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.fieldArea.fullLapArea"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.fieldArea.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.fieldArea, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.fieldArea.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.hectare'),
      "title": _vm.$t('PluviometricChart.units.hectare'),
      "value": "ha"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.acres'),
      "title": _vm.$t('PluviometricChart.units.acres'),
      "value": "acres"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.areaWithCannon'),
      "title": _vm.$t('PluviometricChart.areaWithCannon'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.fieldArea.areaWithCannon),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.fieldArea, "areaWithCannon", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.fieldArea.areaWithCannon"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.cannonRadius'),
      "title": _vm.$t('PluviometricChart.cannonRadius'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.cannonRadius.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.cannonRadius, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.cannonRadius.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.cannonRadius.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.cannonRadius, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.cannonRadius.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.meter'),
      "title": _vm.$t('PluviometricChart.units.meter'),
      "value": "m"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.foot'),
      "title": _vm.$t('PluviometricChart.units.foot'),
      "value": "ft"
    }
  })], 1)], 1)], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "section-text text-left full-width"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.flow'))), _c('v-icon', {
    staticClass: "ml-1",
    on: {
      "click": function($event) {
        _vm.showFlowSection = !_vm.showFlowSection
      }
    }
  }, [_vm._v(_vm._s(_vm.showFlowSection ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1), _vm._v(" "), (_vm.showFlowSection) ? [_c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.flowPerArea'),
      "title": _vm.$t('PluviometricChart.flowPerArea'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerArea.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerArea, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.flowPerArea.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerArea.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerArea, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.flowPerArea.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.litersPerSecond') + ' ' + _vm.$t('PluviometricChart.units.per') + ' ' + _vm.$t('PluviometricChart.units.hectare'),
      "title": _vm.$t('PluviometricChart.units.litersPerSecond') + ' ' + _vm.$t('PluviometricChart.units.per') + ' ' + _vm.$t('PluviometricChart.units.hectare'),
      "value": "lps per ha"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.gallonsPerMinute') + ' ' + _vm.$t('PluviometricChart.units.per') + ' ' + _vm.$t('PluviometricChart.units.acre'),
      "title": _vm.$t('PluviometricChart.units.gallonsPerMinute') + ' ' + _vm.$t('PluviometricChart.units.per') + ' ' + _vm.$t('PluviometricChart.units.acre'),
      "value": "gpm per acre"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.cubicMeter') + '/' + _vm.$t('PluviometricChart.units.hour') + ' ' + _vm.$t('PluviometricChart.units.per') + ' ' + _vm.$t('PluviometricChart.units.hectare'),
      "title": _vm.$t('PluviometricChart.units.cubicMeter') + '/' + _vm.$t('PluviometricChart.units.hour') + ' ' + _vm.$t('PluviometricChart.units.per') + ' ' + _vm.$t('PluviometricChart.units.hectare'),
      "value": "m3/h per ha"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.flowPerDay'),
      "title": _vm.$t('PluviometricChart.flowPerDay'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerDay.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerDay, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.flowPerDay.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerDay.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerDay, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.flowPerDay.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.milimeters') + '/' + _vm.$t('PluviometricChart.units.day'),
      "title": _vm.$t('PluviometricChart.units.milimeters') + '/' + _vm.$t('PluviometricChart.units.day'),
      "value": "mm/day"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.inch') + '/' + _vm.$t('PluviometricChart.units.day'),
      "title": _vm.$t('PluviometricChart.units.inch') + '/' + _vm.$t('PluviometricChart.units.day'),
      "value": "in/day"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.cannonFlow'),
      "title": _vm.$t('PluviometricChart.cannonFlow'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.cannonFlow.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.cannonFlow, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.cannonFlow.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.cannonFlow.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.cannonFlow, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.cannonFlow.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.litersPerSecond'),
      "title": _vm.$t('PluviometricChart.units.litersPerSecond'),
      "value": "lps"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.gallonsPerMinute'),
      "title": _vm.$t('PluviometricChart.units.gallonsPerMinute'),
      "value": "gpm"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.cubicMeter') + '/' + _vm.$t('PluviometricChart.units.hour'),
      "title": _vm.$t('PluviometricChart.units.cubicMeter') + '/' + _vm.$t('PluviometricChart.units.hour'),
      "value": "m3/h"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.fullApplicationRate'),
      "title": _vm.$t('PluviometricChart.fullApplicationRate'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.fullApplicationRate.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.fullApplicationRate, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.fullApplicationRate.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.fullApplicationRate.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.fullApplicationRate, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.fullApplicationRate.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.milimeters'),
      "title": _vm.$t('PluviometricChart.units.milimeters'),
      "value": "mm"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.inch'),
      "title": _vm.$t('PluviometricChart.units.inch'),
      "value": "inch"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.cubicMeter') + '/' + _vm.$t('PluviometricChart.units.hour'),
      "title": _vm.$t('PluviometricChart.units.cubicMeter') + '/' + _vm.$t('PluviometricChart.units.hour'),
      "value": "m3/h"
    }
  })], 1)], 1)], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "section-text text-left full-width"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.pressure')))]), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('PluviometricChart.basePress')) + " *"),
      "title": ((_vm.$t('PluviometricChart.basePress')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberRequired,
      "required": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.basePress.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.basePress, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pressure.basePress.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.basePress.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.basePress, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pressure.basePress.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.bar'),
      "title": _vm.$t('PluviometricChart.units.bar'),
      "value": "bar"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('PluviometricChart.pivotPress')) + " *"),
      "title": ((_vm.$t('PluviometricChart.pivotPress')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberRequired,
      "required": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.pivotPress.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.pivotPress, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pressure.pivotPress.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.pivotPress.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.pivotPress, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pressure.pivotPress.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.bar'),
      "title": _vm.$t('PluviometricChart.units.bar'),
      "value": "bar"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('PluviometricChart.endPress')) + " *"),
      "title": ((_vm.$t('PluviometricChart.endPress')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberRequired,
      "required": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.endPress.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.endPress, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pressure.endPress.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.endPress.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.endPress, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pressure.endPress.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.bar'),
      "title": _vm.$t('PluviometricChart.units.bar'),
      "value": "bar"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.highestElevation'),
      "title": _vm.$t('PluviometricChart.highestElevation'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.highestElevation.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.highestElevation, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pressure.highestElevation.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.highestElevation.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.highestElevation, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pressure.highestElevation.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.meter'),
      "title": _vm.$t('PluviometricChart.units.meter'),
      "value": "m"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.foot'),
      "title": _vm.$t('PluviometricChart.units.foot'),
      "value": "ft"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.lowestElevation'),
      "title": _vm.$t('PluviometricChart.lowestElevation'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.lowestElevation.value),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.lowestElevation, "value", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pressure.lowestElevation.value"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.lowestElevation.unit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pressure.lowestElevation, "unit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pressure.lowestElevation.unit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.meter'),
      "title": _vm.$t('PluviometricChart.units.meter'),
      "value": "m"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.foot'),
      "title": _vm.$t('PluviometricChart.units.foot'),
      "value": "ft"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "section-text text-left full-width"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.pipes'))), _c('v-icon', {
    staticClass: "ml-1",
    on: {
      "click": function($event) {
        _vm.showPipesSection = !_vm.showPipesSection
      }
    }
  }, [_vm._v(_vm._s(_vm.showPipesSection ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1), _vm._v(" "), (_vm.showPipesSection) ? [_c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.tubesQty'),
      "title": _vm.$t('PluviometricChart.tubesQty'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pipes.tubeQuantity),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pipes, "tubeQuantity", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pipes.tubeQuantity"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticStyle: {
      "align-self": "center"
    },
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "mb-0 category-text text-left full-width"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.tubeLength')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pipes.tubeLength),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pipes, "tubeLength", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pipes.tubeLength"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.meter'),
      "title": _vm.$t('PluviometricChart.units.meter'),
      "value": "m"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.foot'),
      "title": _vm.$t('PluviometricChart.units.foot'),
      "value": "ft"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticStyle: {
      "align-self": "center"
    },
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "mb-0 category-text text-left full-width"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.internalDiameter')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pipes.internalDiameterUnit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pipes, "internalDiameterUnit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.pipes.internalDiameterUnit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.milimeters'),
      "title": _vm.$t('PluviometricChart.units.milimeters'),
      "value": "mm"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.inch'),
      "title": _vm.$t('PluviometricChart.units.inch'),
      "value": "in"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.pipes.tubes), function(tube) {
    return [_c('v-row', {
      staticClass: "full-width",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": _vm.$t('PluviometricChart.tubes.length'),
        "title": _vm.$t('PluviometricChart.tubes.length'),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "rules": _vm.rules.numberOptional
      },
      model: {
        value: (tube.length),
        callback: function($$v) {
          _vm.$set(tube, "length", _vm._n($$v))
        },
        expression: "tube.length"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "ml-3",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": _vm.$t('PluviometricChart.tubes.internalDiameter'),
        "title": _vm.$t('PluviometricChart.tubes.internalDiameter'),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "rules": _vm.rules.numberOptional
      },
      model: {
        value: (tube.internalDiameter),
        callback: function($$v) {
          _vm.$set(tube, "internalDiameter", _vm._n($$v))
        },
        expression: "tube.internalDiameter"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "ml-3",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-select', {
      attrs: {
        "menu-props": {
          bottom: true,
          offsetY: true
        },
        "items": _vm.tubeMaterialsItems,
        "item-value": "value",
        "item-text": "name",
        "label": ((_vm.$t('PluviometricChart.tubes.material')) + " *"),
        "title": ((_vm.$t('PluviometricChart.tubes.material')) + " *"),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "rules": _vm.rules.fieldRequired,
        "required": "",
        "validate-on-blur": ""
      },
      model: {
        value: (tube.material),
        callback: function($$v) {
          _vm.$set(tube, "material", $$v)
        },
        expression: "tube.material"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "ml-3",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": _vm.$t('PluviometricChart.tubes.cFactor'),
        "title": _vm.$t('PluviometricChart.tubes.cFactor'),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "rules": _vm.rules.numberOptional
      },
      model: {
        value: (tube.cFactor),
        callback: function($$v) {
          _vm.$set(tube, "cFactor", _vm._n($$v))
        },
        expression: "tube.cFactor"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "ml-3",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": _vm.$t('PluviometricChart.tubes.loss'),
        "title": _vm.$t('PluviometricChart.tubes.loss'),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "rules": _vm.rules.numberOptional
      },
      model: {
        value: (tube.loss),
        callback: function($$v) {
          _vm.$set(tube, "loss", _vm._n($$v))
        },
        expression: "tube.loss"
      }
    })], 1)], 1)]
  })] : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "section-text text-left full-width"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.sprinklerSettings')))]), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('PluviometricChart.sprinklers.spanQty')) + " *"),
      "title": ((_vm.$t('PluviometricChart.sprinklers.spanQty')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional,
      "required": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerSpan.spanQuantity),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerSpan, "spanQuantity", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.flowPerSpan.spanQuantity"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticStyle: {
      "align-self": "center"
    },
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "mb-0 category-text text-left full-width"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.sprinklers.distToCenter')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "rules": _vm.rules.fieldRequired,
      "required": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.sprinklerConfiguration.distanceToCenterUnit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.sprinklerConfiguration, "distanceToCenterUnit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.sprinklerConfiguration.distanceToCenterUnit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.meter'),
      "title": _vm.$t('PluviometricChart.units.meter'),
      "value": "m"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.foot'),
      "title": _vm.$t('PluviometricChart.units.foot'),
      "value": "ft"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticStyle: {
      "align-self": "center"
    },
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "mb-0 category-text text-left full-width"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.sprinklers.dropHeight')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "rules": _vm.rules.fieldRequired,
      "required": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.sprinklerConfiguration.dropHeightUnit),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.sprinklerConfiguration, "dropHeightUnit", $$v)
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.sprinklerConfiguration.dropHeightUnit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.meter'),
      "title": _vm.$t('PluviometricChart.units.meter'),
      "value": "m"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('PluviometricChart.units.foot'),
      "title": _vm.$t('PluviometricChart.units.foot'),
      "value": "ft"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.sprinklerConfiguration.sprinklersPerSpan), function(span, spanIndex) {
    return [_c('v-row', {
      staticClass: "full-width my-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('p', {
      staticClass: "section-text text-left align-content-center mb-0"
    }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.span')) + " " + _vm._s(spanIndex + 1))]), _vm._v(" "), _c('v-col', {
      staticClass: "pl-4",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": ((_vm.$t('PluviometricChart.spans.sprinklerQuantity')) + " *"),
        "title": ((_vm.$t('PluviometricChart.spans.sprinklerQuantity')) + " *"),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "rules": _vm.rules.numberRequired,
        "required": "",
        "validate-on-blur": "",
        "hide-details": "auto"
      },
      model: {
        value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerSpan.spans[spanIndex].sprinklerQuantity),
        callback: function($$v) {
          _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerSpan.spans[spanIndex], "sprinklerQuantity", $$v)
        },
        expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.flowPerSpan.spans[spanIndex].sprinklerQuantity"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "pl-4",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": ((_vm.$t('PluviometricChart.spans.length')) + " *"),
        "title": ((_vm.$t('PluviometricChart.spans.length')) + " *"),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "rules": _vm.rules.numberRequired,
        "required": "",
        "validate-on-blur": "",
        "hide-details": "auto"
      },
      model: {
        value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerSpan.spans[spanIndex].length),
        callback: function($$v) {
          _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.flowPerSpan.spans[spanIndex], "length", $$v)
        },
        expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.flowPerSpan.spans[spanIndex].length"
      }
    })], 1)], 1), _vm._v(" "), _vm._l((span.sprinklers), function(sprinkler, sprinklerIndex) {
      return [_c('v-row', {
        staticClass: "full-width",
        attrs: {
          "no-gutters": ""
        }
      }, [_c('p', {
        staticClass: "align-content-center mb-0"
      }, [_vm._v(_vm._s(_vm.getAbsoluteSprinklerNumber(spanIndex, sprinklerIndex)))]), _vm._v(" "), _c('v-col', {
        staticClass: "mx-3"
      }, [_c('v-checkbox', {
        attrs: {
          "label": ("" + (_vm.$t('PluviometricChart.sprinklers.isClogged')))
        },
        model: {
          value: (sprinkler.isClogged),
          callback: function($$v) {
            _vm.$set(sprinkler, "isClogged", $$v)
          },
          expression: "sprinkler.isClogged"
        }
      })], 1), _vm._v(" "), (!sprinkler.isClogged) ? [_c('v-col', [_c('v-text-field', {
        attrs: {
          "label": ((_vm.$t('PluviometricChart.sprinklers.distToCenter')) + " *"),
          "title": ((_vm.$t('PluviometricChart.sprinklers.distToCenter')) + " *"),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "rules": _vm.rules.numberRequired,
          "required": "",
          "validate-on-blur": "",
          "hide-details": "auto"
        },
        model: {
          value: (sprinkler.distanceToCenter),
          callback: function($$v) {
            _vm.$set(sprinkler, "distanceToCenter", _vm._n($$v))
          },
          expression: "sprinkler.distanceToCenter"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        staticClass: "ml-2"
      }, [_c('v-select', {
        attrs: {
          "items": _vm.sprinklersBrands,
          "item-value": "value",
          "item-text": "name",
          "label": ((_vm.$t('PluviometricChart.sprinklers.sprinklerBrand')) + " *"),
          "title": ((_vm.$t('PluviometricChart.sprinklers.sprinklerBrand')) + " *"),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "rules": _vm.rules.fieldRequired,
          "required": "",
          "validate-on-blur": "",
          "hide-details": "auto"
        },
        model: {
          value: (sprinkler.sprinklerBrand),
          callback: function($$v) {
            _vm.$set(sprinkler, "sprinklerBrand", $$v)
          },
          expression: "sprinkler.sprinklerBrand"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        staticClass: "ml-2"
      }, [_c('v-select', {
        attrs: {
          "items": _vm.sprinklersModels(sprinkler.sprinklerBrand),
          "item-value": "value",
          "item-text": "name",
          "label": ((_vm.$t('PluviometricChart.sprinklers.sprinklerModel')) + " *"),
          "title": ((_vm.$t('PluviometricChart.sprinklers.sprinklerModel')) + " *"),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "rules": _vm.rules.fieldRequired,
          "required": "",
          "validate-on-blur": "",
          "disabled": !sprinkler.sprinklerBrand,
          "hide-details": "auto"
        },
        model: {
          value: (sprinkler.sprinklerModel),
          callback: function($$v) {
            _vm.$set(sprinkler, "sprinklerModel", $$v)
          },
          expression: "sprinkler.sprinklerModel"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        staticClass: "ml-2"
      }, [_c('v-select', {
        attrs: {
          "items": _vm.sprinklersSizes(sprinkler.sprinklerBrand, sprinkler.sprinklerModel),
          "item-text": "size",
          "item-value": "size",
          "label": ((_vm.$t('PluviometricChart.sprinklers.nozzleSize')) + " *"),
          "title": ((_vm.$t('PluviometricChart.sprinklers.nozzleSize')) + " *"),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "rules": _vm.rules.fieldRequired,
          "required": "",
          "validate-on-blur": "",
          "disabled": !sprinkler.sprinklerModel,
          "hide-details": "auto",
          "return-object": ""
        },
        model: {
          value: (sprinkler.nozzleSize),
          callback: function($$v) {
            _vm.$set(sprinkler, "nozzleSize", $$v)
          },
          expression: "sprinkler.nozzleSize"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        staticClass: "ml-2"
      }, [_c('v-text-field', {
        attrs: {
          "label": _vm.$t('PluviometricChart.sprinklers.wearPad'),
          "title": _vm.$t('PluviometricChart.sprinklers.wearPad'),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "hide-details": "auto"
        },
        model: {
          value: (sprinkler.wearPad),
          callback: function($$v) {
            _vm.$set(sprinkler, "wearPad", $$v)
          },
          expression: "sprinkler.wearPad"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        staticClass: "ml-2"
      }, [_c('v-text-field', {
        attrs: {
          "label": ((_vm.$t('PluviometricChart.sprinklers.dropHeight')) + " *"),
          "title": ((_vm.$t('PluviometricChart.sprinklers.dropHeight')) + " *"),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "rules": _vm.rules.numberRequired,
          "required": "",
          "validate-on-blur": "",
          "hide-details": "auto"
        },
        model: {
          value: (sprinkler.dropHeight),
          callback: function($$v) {
            _vm.$set(sprinkler, "dropHeight", _vm._n($$v))
          },
          expression: "sprinkler.dropHeight"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        staticClass: "ml-2"
      }, [_c('v-select', {
        attrs: {
          "items": [10, 15],
          "label": ((_vm.$t('PluviometricChart.sprinklers.regulator')) + " *"),
          "title": ((_vm.$t('PluviometricChart.sprinklers.regulator')) + " *"),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "rules": _vm.rules.numberRequired,
          "required": "",
          "validate-on-blur": "",
          "hide-details": "auto"
        },
        model: {
          value: (sprinkler.regulator),
          callback: function($$v) {
            _vm.$set(sprinkler, "regulator", _vm._n($$v))
          },
          expression: "sprinkler.regulator"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        staticClass: "ml-2"
      }, [_c('v-text-field', {
        attrs: {
          "label": ((_vm.$t('PluviometricChart.sprinklers.outletPressure')) + " *"),
          "title": ((_vm.$t('PluviometricChart.sprinklers.outletPressure')) + " *"),
          "outlined": "",
          "background-color": "#FFF",
          "color": "#0098E1",
          "rules": _vm.rules.numberRequired,
          "required": "",
          "validate-on-blur": "",
          "hide-details": "auto"
        },
        model: {
          value: (sprinkler.outletPressure),
          callback: function($$v) {
            _vm.$set(sprinkler, "outletPressure", _vm._n($$v))
          },
          expression: "sprinkler.outletPressure"
        }
      })], 1)] : _vm._e()], 2)]
    })]
  }), _vm._v(" "), _c('p', {
    staticClass: "section-text text-left full-width"
  }, [_vm._v(_vm._s(_vm.$t('PluviometricChart.lrdu'))), _c('v-icon', {
    staticClass: "ml-1",
    on: {
      "click": function($event) {
        _vm.showLRDUSection = !_vm.showLRDUSection
      }
    }
  }, [_vm._v(_vm._s(_vm.showLRDUSection ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1), _vm._v(" "), (_vm.showLRDUSection) ? [_c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.rpm'),
      "title": _vm.$t('PluviometricChart.rpm'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.rpm),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain, "rpm", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.rpm"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "ml-3",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.frequency'),
      "title": _vm.$t('PluviometricChart.frequency'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.frequency),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain, "frequency", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.frequency"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.highFloat'),
      "title": _vm.$t('PluviometricChart.highFloat'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.highFloat),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain, "highFloat", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.highFloat"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.wheelGBRatio'),
      "title": _vm.$t('PluviometricChart.wheelGBRatio'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.wheelGbRatio),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain, "wheelGbRatio", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.wheelGbRatio"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.lrduDist'),
      "title": _vm.$t('PluviometricChart.lrduDist'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.lrduDist),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain, "lrduDist", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.lrduDist"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "full-width",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.hoursPer360'),
      "title": _vm.$t('PluviometricChart.hoursPer360'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.hoursPer360),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain, "hoursPer360", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.hoursPer360"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "ml-3",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('PluviometricChart.distancePerTime'),
      "title": _vm.$t('PluviometricChart.distancePerTime'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.rules.numberOptional
    },
    model: {
      value: (_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.distancePerTime),
      callback: function($$v) {
        _vm.$set(_vm.pluviometricChartsData[_vm.selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain, "distancePerTime", _vm._n($$v))
      },
      expression: "pluviometricChartsData[selectedPluviometricConfiguration].advancedConfiguration.lrduDriveTrain.distancePerTime"
    }
  })], 1)], 1)] : _vm._e()], 2)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingCharts) ? _c('v-row', {
    staticClass: "mt-3 device-editor-button-row",
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', {
    staticClass: "align-center",
    attrs: {
      "cols": "12",
      "sm": "4",
      "offset-sm": "4"
    }
  }, [_c('v-btn', {
    staticClass: "form-confirmation-button",
    attrs: {
      "block": "",
      "color": "#0098E1",
      "large": "",
      "dark": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveHandler
    }
  }, [_vm._v(_vm._s(_vm.$t('AddDevice.register')))])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38dd5df4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddDevice/DeviceEditor.vue
// module id = 1701
// module chunks = 0